<div class="axis-content-wrapper">
  <div class="axis-container-fluid">
    <div>
      <img
        alt="AIG logo"
        class="aig-logo"
        src="assets/images/logos/aig-logo-blue.svg"
      />
      <span class="_sr-only">American International Group, Inc.</span>
    </div>
    <div class="initial-empty-container">
      <img
        alt=""
        class="axis-img-responsive _mlr-auto"
        src="assets/images/messages/no-data-available.svg"
        loading="lazy"
      />
      <div
        class="axis-title"
        role="heading"
        aria-level="1"
      >
       Thanks for choosing AIG
      </div>
    
     
        <p>
        This page is no longer available. Thank you for completing and signing your coverage selection forms.  Please reach out to your broker if you have any questions.
        </p>
     
         
      
   
    </div>
  </div>
</div>
